var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarIcon = function SvgCarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F7F8FC",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M6.13 9.085a.63.63 0 1 0 0 1.26h1.827l2.198 8.548a1.53 1.53 0 0 0 1.482 1.15h7.721a1.53 1.53 0 0 0 1.475-1.124l1.765-6.395a.63.63 0 0 0-1.215-.335l-1.765 6.395a.27.27 0 0 1-.26.198h-7.72a.27.27 0 0 1-.262-.202L9.09 9.693a.81.81 0 0 0-.784-.608zm10.19 2.587a.63.63 0 0 0-1.26 0v1.53h-1.53a.63.63 0 1 0 0 1.26h1.53v1.53a.63.63 0 1 0 1.26 0v-1.53h1.53a.63.63 0 1 0 0-1.26h-1.53zm-2.924 10.193a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0m7.2 0a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0",
    clipRule: "evenodd"
  })));
};
export default SvgCarIcon;